<template>
    <div class="tabla_footer">
        <span>Mostrar filas:</span>
        <span><select v-model="pageSizeSelected">
							<option v-for="p in pageSizes" :value="p">{{p}}</option>
						</select>
				</span>
        <span>{{(page  - 1) * pageSize + 1 }} - {{getLastResult()}} de {{total}}</span>
        <span><a href="javascript:void(0)" @click="changePage(page-1)"
                 :class="`paginador ${page === 1 ? 'disabled' : ''}`"><i
            class="mdi mdi-chevron-left"></i></a>
					<a href="javascript:void(0)"
                       @click="changePage(1)"
                       :class="`paginador ${page === 1 ? 'disabled' : ''}`"><i
                        class="mdi mdi-chevron-double-left"></i></a>
					<a href="javascript:void(0)"
                       @click="changePage(pages)"
                       :class="`paginador ${page === pages ? 'disabled' : ''}`"><i
                        class="mdi mdi-chevron-double-right"></i></a>
					<a href="javascript:void(0)" @click="changePage(page+1)"
                       :class="`paginador ${page === pages ? 'disabled' : ''}`"><i
                        class="mdi mdi-chevron-right"></i></a>
				</span>
    </div>
</template>
<style>

</style>

<script>
    export default {
        props: {
            total: {
                type: Number,
                required: true
            },
            page: {
                type: Number,
                required: true
            },
            pageSize: {
                type: Number,
                required: true
            },
            pages: {
                type: Number,
                required: true
            },
            changePage: {
                type: Function,
                required: true
            },
            changePageSize: {
                type: Function,
                required: true
            }
        },
        watch: {
            pageSizeSelected: function () {
                this.changePageSize(this.pageSizeSelected);
            }
        },
        data() {
            return {
                pageSizes: [20, 40, 60, 80, 100],
                pageSizeSelected: 20
            }
        },
        methods: {
            getLastResult() {
                const self = this;
                if (self.total < self.pageSize || self.pageSize * self.page > self.total) {
                    return self.total;
                } else {
                    return self.pageSize * self.page;
                }
            }
        },
    }
</script>




// WEBPACK FOOTER //
// src/components/common/Paginator.vue